export default "__VITE_ASSET__CWuVLe5R__"